import styled from 'styled-components'

export const PickupTableClientBlock = styled.div`
  display: flex;
  align-items: center;
  margin: 25px 0;

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  div:first-child {
    margin-right: 15px;
  }

  div:nth-child(2) {
    font-size: ${props => props.theme.fontSizes.pickup.table.clientBlock};
  }
`



// WEBPACK FOOTER //
// ./src/Components/City/Page/Pickup/PickupTable/ClientBlock/index.js